import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslatorService } from '../services/_core/translator/translator.service';

/**
 * Async pipe helper for Amazon Translate of dynamic content (titles, descriptions).
 * Usage: {{ text | awsTranslate | async }}
 */
@Pipe({
  name: 'awsTranslate',
  standalone: true,
  pure: false
})
export class AwsTranslatePipe implements PipeTransform {
  private lastText: string | null | undefined;
  private lastLang: string | null = null;
  private lastStream: Observable<string> | null = null;

  constructor(private translator: TranslatorService) {}

  transform(text: string | null | undefined): Observable<string> {
    const lang = this.translator.getPreferredLanguage();
    if (text === this.lastText && lang === this.lastLang && this.lastStream) {
      return this.lastStream;
    }
    this.lastText = text;
    this.lastLang = lang;
    this.lastStream = this.translator.translateDynamic$(text);
    return this.lastStream ?? of(text ?? '');
  }
}
